// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useContext, useMemo, useState } from 'react';
import MemberContext from './MemberContext';
import { Auth } from 'aws-amplify';
import { WEBSOCKET_URL } from '../configuration';

export interface WebSocketContextType {
  websocket?: WebSocket;
}

export const defaultWebSocket: WebSocketContextType = {}

export const WebSocketContext = React.createContext({
  ...defaultWebSocket,
  connectWebsocket: () => console.log('connect Websocket'),
  disconnectWebsocket: () => console.log('disconnect Websocket'),
});

export function WebSocketContextProvider(props: React.ComponentProps<'div'>): JSX.Element {
  const { children } = props;
  const member = useContext(MemberContext);
  const [state, setState] = useState<WebSocketContextType>({
    websocket: undefined,
  })

  const connectWebsocket = () => {
    const cognitoKey = localStorage.getItem('CognitoKey');
    const idToken = localStorage.getItem(`${cognitoKey}.IdToken`)
    if (idToken) {
      const endpoint = `${WEBSOCKET_URL}?Authorization=${idToken}`;
      const ws = new WebSocket(endpoint)
      setState({ websocket: ws });
    } else {
      Auth.currentUserPoolUser().then((data) => {
        const idToken = data
          ? data.signInUserSession.idToken.jwtToken
          : '';
        const endpoint = `${WEBSOCKET_URL}?Authorization=${idToken}`;
        const ws = new WebSocket(endpoint)
        // ws.addEventListener('message', function (event) {
        //   console.log(event.data)
        // });
        setState({ websocket: ws });
      }).catch((error) => {
        console.log('Token expired or No login', { error })
      });
    }
  }

  const disconnectWebsocket = () => {
    console.log()
    if (state.websocket) {
      state.websocket.close()
      setState(defaultWebSocket)
    }
  }

  // useEffect(() => {
  //   if (member.isLogin) {
  //     connectWebsocket()
  //   } else {
  //     disconnectWebsocket()
  //   }
  // }, [member.isLogin]);

  const value = useMemo(() => {
    return {
      ...state,
      connectWebsocket,
      disconnectWebsocket,
    }
  }, [state, connectWebsocket, disconnectWebsocket])

  return (
    <WebSocketContext.Provider value={value}>
      {children}
    </WebSocketContext.Provider>
  )
}

export default WebSocketContext;
